import {UPDATE_PASSWORD} from '../actions/types';

const initialState = {
};

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PASSWORD:
      return {
        ...state,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.jsx